import { createExecutorMap, MemoryStore } from "@dataspecer/core/core";
import { dataPsmExecutors } from "@dataspecer/core/data-psm/data-psm-executors";
import { pimExecutors } from "@dataspecer/core/pim/executor";
/**
 * Naive implementation of {@link MemoryStore} that can synchronize data with
 * the server using simple HTTP api.
 */
export class MemoryStoreFromBlob extends MemoryStore {
    connector;
    constructor(baseIri, executors, createNewIdentifier, connector) {
        super(baseIri, executors, createNewIdentifier);
        this.connector = connector;
    }
    async save() {
        const operations = this.operations;
        const resources = this.resources;
        await this.connector.save({ operations, resources });
    }
    async load() {
        const { operations, resources } = await this.connector.load();
        this.operations = operations;
        this.resources = resources;
    }
    static createFromConnector(connector) {
        return new MemoryStoreFromBlob("https://ofn.gov.cz", createExecutorMap([...dataPsmExecutors, ...pimExecutors]), null, connector);
    }
}
export function blobModelAsConnector(blobModel) {
    return {
        load: () => blobModel.getJsonBlob(),
        save: (data) => blobModel.setJsonBlob(data),
    };
}
//# sourceMappingURL=memory-store.js.map